var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubpagesVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 803,
    height: 648,
    viewBox: "0 0 803 648",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_54_11",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 655,
    height: 340
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.0001,
    y: -0.0000610352,
    width: 654,
    height: 340,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_54_11)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M278.525 485.34C42.9622 564.898 163.687 113.458 294.592 235.627C359.724 296.413 457.186 143.997 506.276 221.815C555.391 299.575 492.589 341.694 460.781 426.366C421.457 532.244 340.905 464.274 278.532 485.338L278.525 485.34Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M279.758 490.258C52.9763 556.745 157.313 124.906 292.221 232.422C358.712 285.412 465.153 150.307 508.586 228.871C552.07 307.319 494.99 353.858 459.899 431.124C416.131 527.496 341.532 472.144 279.758 490.258Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M280.992 495.182C63.2958 548.942 150.679 136.333 289.854 229.22C357.577 274.419 473.122 156.611 510.905 235.931C548.758 315.068 497.578 366.072 459.029 435.888C411.038 522.808 342.265 480.049 280.992 495.182Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M282.224 500.099C73.9223 541.539 143.761 147.796 287.486 226.011C356.299 263.46 481.092 162.916 513.221 242.978C545.446 322.806 500.189 378.246 458.154 440.644C405.98 518.087 343.092 487.989 282.224 500.099Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M283.454 505.021C84.8345 534.609 136.563 159.39 285.115 222.806C354.882 252.592 489.061 169.221 515.535 250.036C542.127 330.557 502.843 390.421 457.276 445.403C400.963 513.354 344.006 496.001 283.454 505.021Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M284.691 509.941C96.0198 528.218 129.124 171.213 282.749 219.604C353.356 241.845 497.028 175.53 517.85 257.094C538.814 338.306 505.537 402.598 456.402 450.166C396.008 508.63 345.015 504.098 284.689 509.945L284.691 509.941Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M285.921 514.863C107.424 522.423 121.502 183.337 280.382 216.402C351.742 231.251 504.999 181.843 520.169 264.155C535.502 346.055 508.287 414.796 455.529 454.929C391.12 503.929 346.105 512.319 285.918 514.867L285.921 514.863Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M287.153 519.78C119.001 517.262 113.779 195.821 278.014 213.193C350.082 220.818 512.971 188.143 522.484 271.201C532.186 353.79 511.077 427.014 454.656 459.679C386.283 499.26 347.263 520.679 287.153 519.78Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M288.39 524.7C130.676 512.775 106.064 208.684 275.648 209.991C348.424 210.552 520.939 194.452 524.799 278.26C528.873 361.539 513.896 439.306 453.782 464.442C381.481 494.675 348.453 529.244 288.388 524.704L288.39 524.7Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M289.62 529.622C142.351 508.968 98.4278 221.908 273.277 206.786C346.802 200.431 528.908 200.757 527.114 285.318C525.556 369.286 516.725 451.652 452.904 469.202C376.682 490.158 349.65 538.04 289.618 529.626L289.62 529.622Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M290.853 534.539C153.93 505.818 90.9502 235.44 270.909 203.577C345.246 190.418 536.878 207.062 529.427 292.369C522.242 377.027 519.54 464.057 452.029 473.957C371.875 485.71 350.801 547.113 290.848 534.536L290.853 534.539Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M292.087 539.463C165.29 503.283 83.6714 249.225 268.54 200.38C343.78 180.504 544.842 213.376 531.746 299.43C518.93 384.777 522.337 476.518 451.159 478.722C367.046 481.322 351.855 556.518 292.087 539.463Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M293.319 544.38C176.296 501.262 76.6116 263.171 266.176 197.173C342.405 170.63 552.818 219.679 534.063 306.483C515.62 392.521 525.097 489.005 450.284 483.477C362.168 476.965 352.727 566.274 293.319 544.38Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M294.556 549.3C186.824 499.64 69.7696 277.229 263.812 193.967C341.122 160.794 560.792 225.986 536.384 313.539C512.309 400.266 527.825 501.509 449.417 488.237C357.253 472.633 353.348 576.405 294.56 549.303L294.556 549.3Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M295.786 554.222C196.745 498.256 63.1241 291.343 261.441 190.762C339.918 150.959 568.757 232.289 538.695 320.595C508.986 408.014 530.514 514.025 448.535 492.995C352.286 468.305 353.603 586.896 295.782 554.219L295.786 554.222Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M297.018 559.139C205.949 496.913 56.661 305.454 259.071 187.557C338.79 141.122 576.724 238.598 541.01 327.653C505.674 415.763 533.176 526.536 447.661 497.757C347.296 463.976 353.438 597.698 297.016 559.143L297.018 559.139Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M208.122 218.473C133.833 -180.332 665.683 198.969 487.769 337.747C398.678 407.238 584.6 602.625 486.816 655.64C389.026 708.652 354.814 591.971 250.96 515.503C121.259 420.009 227.325 321.522 208.124 218.468L208.122 218.473Z",
    stroke: "#20DDA2",
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.94
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M202.196 218.481C142.231 -163.269 653.186 185.397 491.851 335.402C411.694 409.929 576.111 612.174 478.241 656.471C380.436 700.826 340.028 591.424 245.521 512.43C127.281 414.33 218.034 319.258 202.203 218.479L202.196 218.481Z",
    stroke: "#20DDA2",
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.88
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M196.275 218.492C150.308 -145.899 640.872 171.418 495.93 333.063C424.772 412.419 567.617 621.72 469.667 657.301C371.849 692.995 325.516 590.534 240.079 509.354C133.634 408.22 208.714 317.093 196.275 218.492Z",
    stroke: "#20DDA2",
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.81
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M190.35 218.5C158.003 -128.216 628.64 156.965 500.009 330.723C437.862 414.672 559.123 631.266 461.093 658.131C363.259 685.169 310.894 589.863 234.637 506.278C139.849 402.38 199.355 315.032 190.35 218.5Z",
    stroke: "#20DDA2",
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.75
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M184.425 218.509C165.236 -110.217 616.364 142.012 504.088 328.383C450.9 416.673 550.634 640.814 452.523 658.964C354.675 677.341 296.277 589.233 229.199 503.205C146.067 396.596 189.947 313.086 184.429 218.511L184.425 218.509Z",
    stroke: "#20DDA2",
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.69
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M178.499 218.517C171.947 -91.9189 603.899 126.586 508.163 326.041C463.816 418.437 542.133 650.362 443.944 659.792C346.081 669.512 281.657 588.642 223.753 500.127C152.281 390.865 180.453 311.247 178.495 218.514L178.499 218.517Z",
    stroke: "#20DDA2",
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.62
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M172.574 218.525C178.047 -73.3426 591.106 110.765 512.245 323.697C476.57 420.015 533.642 659.904 435.372 660.618C337.496 661.677 267.024 588.106 218.317 497.049C158.484 385.195 170.872 309.518 172.577 218.521L172.574 218.525Z",
    stroke: "#20DDA2",
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.56
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M166.649 218.534C183.459 -54.5358 577.901 94.6792 516.324 321.357C489.13 421.471 525.153 669.452 426.798 661.449C328.906 653.851 252.365 587.62 212.875 493.973C164.642 379.588 161.152 307.881 166.649 218.534Z",
    stroke: "#20DDA2",
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.5
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M160.728 218.545C188.117 -35.5574 564.226 78.4653 520.403 319.018C501.482 422.87 516.659 678.998 418.228 662.282C320.318 646.02 237.664 587.181 207.44 490.896C170.752 374.031 151.266 306.322 160.73 218.54L160.728 218.545Z",
    stroke: "#20DDA2",
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.44
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M154.803 218.553C191.967 -16.5036 550.095 62.2596 524.483 316.678C513.649 424.276 508.17 688.547 409.654 663.112C311.728 638.194 222.9 586.765 201.997 487.82C176.787 368.506 141.166 304.814 154.805 218.549L154.803 218.553Z",
    stroke: "#20DDA2",
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.38
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M148.877 218.561C194.965 2.5132 535.556 46.1719 528.562 314.338C525.655 425.741 499.673 698.097 401.08 663.943C303.141 630.363 208.076 586.353 196.559 484.747C182.754 362.994 130.804 303.3 148.884 218.56L148.877 218.561Z",
    stroke: "#20DDA2",
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.31
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M142.952 218.57C197.122 21.3468 520.67 30.2782 532.637 311.996C537.532 427.29 491.176 707.641 392.503 664.778C294.548 622.542 193.19 585.934 191.115 481.676C188.641 357.462 120.116 301.718 142.95 218.575L142.952 218.57Z",
    stroke: "#20DDA2",
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.25
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M137.027 218.578C198.476 39.8185 505.527 14.6142 536.716 309.656C549.328 428.936 482.688 717.185 383.931 665.604C285.963 614.706 178.257 585.472 185.675 478.596C194.474 351.891 109.053 299.968 137.027 218.578Z",
    stroke: "#20DDA2",
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.19
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M131.101 218.587C199.122 57.7304 490.198 -0.798046 540.798 307.312C561.059 430.693 474.195 726.731 375.357 666.434C277.373 606.88 163.276 584.975 180.233 475.52C200.256 346.27 97.5501 297.93 131.101 218.587Z",
    stroke: "#20DDA2",
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.12
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M125.176 218.595C199.227 74.8512 474.742 -15.9713 544.872 304.97C572.752 432.556 465.701 736.277 366.778 667.262C268.781 599.047 148.269 584.43 174.786 472.442C206.006 340.591 85.5756 295.45 125.172 218.592L125.176 218.595Z",
    stroke: "#20DDA2",
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.06
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M119.255 218.606C199.04 90.9619 459.222 -30.9276 548.956 302.633C584.435 434.51 457.209 745.83 358.213 668.098C260.2 591.226 133.266 583.846 169.357 469.374C211.763 334.868 73.1563 292.362 119.257 218.613L119.255 218.606Z",
    stroke: "#20DDA2",
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M405.212 166.42C720.691 -37.2585 662.15 650.577 445.08 527.336C337.117 466.036 236.655 720.017 147.232 628.344C57.7881 536.762 136.6 452.783 160.606 320.27C189.98 154.74 321.759 220.303 405.21 166.425L405.212 166.42Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M402.218 159.904C708.657 -21.9248 668.415 631.889 449.253 530.977C341.35 481.289 223.73 714.119 142.16 619.211C60.5552 524.483 130.106 436.453 160.649 313.169C198.731 159.471 318.922 209.33 402.212 159.906L402.218 159.904Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M399.229 153.392C696.115 -6.93311 675.089 613.146 453.428 534.618C345.776 496.478 210.798 708.224 137.09 610.073C63.3293 512.202 123.358 420.104 160.697 306.071C207.161 164.178 315.956 198.355 399.225 153.389L399.229 153.392Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M396.235 146.876C683.04 7.62638 682.175 594.212 457.606 538.262C350.399 511.552 197.87 702.33 132.026 600.945C66.1025 499.933 116.578 403.803 160.753 298.978C215.551 168.939 312.859 187.36 396.239 146.878L396.235 146.876Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M393.245 140.363C669.424 21.6515 689.616 574.963 461.78 541.904C355.19 526.437 184.943 696.437 126.954 591.812C68.8698 487.653 109.747 387.524 160.799 291.884C223.869 173.73 309.601 176.319 393.245 140.363Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M390.254 133.842C655.276 35.0499 697.331 555.272 465.954 545.545C360.108 541.095 172.011 690.541 121.882 582.679C71.6414 475.377 102.849 371.253 160.842 284.783C232.11 178.526 306.19 165.182 390.247 133.844L390.254 133.842Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M387.265 127.329C640.629 47.7192 705.186 535.063 470.134 549.184C365.09 555.493 159.088 684.638 116.817 573.543C74.4154 463.096 95.8883 354.974 160.894 277.688C240.273 183.311 302.636 153.919 387.262 127.334L387.265 127.329Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M384.271 120.814C625.534 59.5631 713.037 514.3 474.308 552.826C370.066 569.649 146.16 678.745 111.749 564.413C77.1869 450.82 88.859 338.663 160.946 270.593C248.35 188.054 298.95 142.481 384.275 120.816L384.271 120.814Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M381.281 114.301C610.073 70.4988 720.752 493.006 478.482 556.467C374.982 583.578 133.228 672.849 106.679 555.275C79.9607 438.539 81.7764 322.283 160.996 263.49C256.359 192.712 295.135 130.785 381.283 114.296L381.281 114.301Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M378.292 107.788C594.372 80.4872 728.219 471.255 482.66 560.111C379.801 597.329 120.301 666.956 101.611 546.145C82.7325 426.262 74.6585 305.831 161.042 256.396C264.327 197.289 291.234 118.784 378.29 107.78L378.292 107.788Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M375.3 101.267C578.575 89.4854 735.361 449.148 486.834 563.752C384.48 610.949 107.373 661.063 96.5393 537.012C85.4998 413.983 67.5341 289.296 161.09 249.298C272.29 201.759 287.295 106.367 375.3 101.267Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M372.31 94.7543C562.871 97.5129 742.161 426.79 491.008 567.394C389.017 624.494 94.4413 655.167 91.4669 527.879C88.2668 401.704 60.4225 272.683 161.135 242.204C280.272 206.149 283.386 93.4673 372.304 94.7562L372.31 94.7543Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M369.317 88.2387C547.476 104.631 748.609 404.286 495.186 571.038C393.417 638.001 81.5163 649.27 86.4035 518.751C91.0446 389.438 53.354 256.011 161.191 235.112C288.303 210.471 279.621 79.99 369.321 88.2414L369.317 88.2387Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M366.327 81.7254C532.639 110.966 754.745 381.721 499.36 574.679C397.686 651.499 68.5885 643.376 81.3336 509.613C93.8141 377.154 46.3205 239.293 161.237 228.006C296.38 214.737 276.089 65.8503 366.325 81.7182L366.327 81.7254Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M363.333 75.2098C518.603 116.701 760.593 359.166 503.534 578.32C401.841 665.019 55.6568 637.48 76.2616 500.48C96.5815 364.875 39.3257 222.558 161.282 220.913C304.502 218.982 272.947 51.0544 363.333 75.2098Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M360.346 68.6923C505.605 122.08 766.212 336.657 507.712 581.965C405.902 678.578 42.7292 631.587 71.1938 491.35C99.3573 352.601 32.3776 205.808 161.335 213.817C312.682 223.214 270.349 35.6193 360.346 68.6923Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.37,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubpagesVector);
export default __webpack_public_path__ + "static/media/subpages-vector.fc39f63eb3d6eaaccc0364fa70da1b7a.svg";
export { ForwardRef as ReactComponent };